"use strict";
// import {v} from "suretype"
// import type {TypeOf} from "suretype"
// import * as auth from "./auth"
// import * as communities from "./communities"
// import * as user from "./user"
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./apps"), exports);
__exportStar(require("./auth"), exports);
__exportStar(require("./communities"), exports);
__exportStar(require("./user"), exports);
__exportStar(require("./common"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./oauth"), exports);
__exportStar(require("./invoices"), exports);
// export const apiArgsSchema = v.anyOf([
//
//     // ==========================
//     // auth
//     // ==========================
//
//     // account info
//     auth.updateEmailArgsSchema,
//     auth.updateNameArgsSchema,
//
//     // user secrets
//     auth.createUserSecretsArgsSchema,
//     auth.mergeUserSecretsArgsSchema,
//     // // send email
//     // auth.sendVerificationEmailArgsSchema,
//     // auth.sendSignInEmailArgsSchema
//
//
//     // ==========================
//     // user
//     // ==========================
//
//     // device token
//     user.addDeviceTokenArgsSchema,
//
//     // inbox
//     user.markInboxMessageAsReadArgsSchema,
//
//
//     // ==========================
//     // community
//     // ==========================
//
//     // community
//     communities.createCommunityArgsSchema,
//     communities.joinCommunityArgsSchema,
//     communities.previewCommunityArgsSchema,
//     communities.deleteCommunityArgsSchema,
//     communities.leaveCommunityArgsSchema,
//     communities.leavePreviewArgsSchema,
//
//     // invitation link
//     communities.createInvitationLinkArgsSchema,
//     communities.deleteInvitationLinkArgsSchema,
//     communities.getCommunityInvitationLinkArgsSchema,
//     // TODO delete getInvitationLinkArgsSchema
//     communities.getInvitationLinkArgsSchema,
//
//     // members
//     communities.addMonthlyActiveUserArgsSchema,
//
//     // channels
//     communities.toggleChannelMuteArgsSchema,
//     communities.updateLibraryPayloadSchema,
//
//     // channel user secrets
//     // NOTE channel user secrets are update by other actions such as up-voting
//
//     // --------------------------
//     // chat channel
//     // --------------------------
//     communities.createChatCommentArgsSchema,
//     communities.deleteChatCommentArgsSchema,
//     communities.updateChatCommentArgsSchema,
//     communities.toggleChatCommentReactionArgsSchema,
//
//     // --------------------------
//     // document channel
//     // --------------------------
//     communities.createIssueArgsSchema,
//     communities.toggleIssueSubscriptionArgsSchema,
//     communities.markIssueAsViewedArgsSchema,
//     communities.setAcceptedAnswerArgsSchema,
//
//     communities.createAnswerArgsSchema,
//
//     communities.updatePostArgsSchema,
//     communities.deletePostArgsSchema,
//     communities.togglePostReactionArgsSchema
// ])
//
// export type ApiArgs = TypeOf<typeof apiArgsSchema>
// export type apiCommands = ApiArgs["cmd"]
